// extracted by mini-css-extract-plugin
export var light_bg = "index-module--light_bg--BoRRO";
export var linear_background = "index-module--linear_background--k-FF+";
export var radial_background = "index-module--radial_background--V79B8";
export var small_egg_bg = "index-module--small_egg_bg--BWsMv";